/* unchanged styles, just renamed import path */
import React from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";

import Classes from "../styles/style.module.css";

const CoralCheckbox = styled(Checkbox)({
  "&&": {
    padding: 5,
    color: "#f26a63",
    "& .MuiSvgIcon-root": { fontSize: 17 },
    "&.Mui-checked": { color: "#f26a63" },
  },
});

export default function DropDownElem({
  filter,
  index,
  selectedOptions,
  onOptionChange,
  searchTerm,
}) {
  const opts = filter.options.filter((o) =>
    o.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={Classes.filterElem}>
      <Accordion
        sx={{
          boxShadow: "none !important",
          border: "none !important",
          borderRadius: "10px !important",
          mb: "10px !important",
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          sx={{
            minHeight: "25px !important",
            paddingLeft: "0 !important",
            margin: '0 !important',
            ".MuiAccordionSummary-content": { margin: 0 },
          }}
        >
          <div className={Classes.selectionCon}>
            <img src="/assets/icons/arrow-down.svg" alt="" className={Classes.iconCon} />
            <h5 className={Classes.SelectionTitle}>{filter.title}</h5>
          </div>
        </AccordionSummary>

        <AccordionDetails className={Classes.accordionBody} sx={{ p: 0 }}>
          {opts.length ? (
            opts.map((o, j) => {
              const id = `cb-${index}-${j}`;
              const checked = selectedOptions.includes(o);
              return (
                <div key={j} className={Classes.dropDownElem}>
                  <CoralCheckbox
                    id={id}
                    checked={checked}
                    onChange={(e) => onOptionChange(filter.title, o, e.target.checked)}
                  />
                  <label htmlFor={id}>
                    <h5>{o}</h5>
                  </label>
                </div>
              );
            })
          ) : (
            <div className={Classes.noOptions}>
              <h5>No options found</h5>
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
